import { Component, OnInit, HostListener, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../services/api.service';

@Component({
    selector: 'app-main-header',
    templateUrl: './main-header.component.html',
    styleUrls: ['./main-header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MainHeaderComponent implements OnInit {
  @Input() backgroundImage: string = '/assets/images/banner-main.png';
  @Input() showHeaderButtons: boolean = true;
  @Input() isTransparent: boolean = true;
  @Input() isImage: boolean = true;
  
  currentLang: string = 'tr';
  isScrolled: boolean = false;

  constructor(
    public router: Router,
    private translateService: TranslateService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.currentLang = this.translateService.getCurrentLang() || 'tr';
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    const header = document.getElementById('main-header');
    
    if (header) {
      if (window.pageYOffset > 300) {
        header.classList.add('scrolled');
        this.isScrolled = true;
      } else {
        header.classList.remove('scrolled');
        this.isScrolled = false;
      }
    }
  }

  changeLang(lang: string): void {
    this.currentLang = lang;
    this.translateService.use(lang);
    this.apiService.setCurrentLang(lang);
  }

  navigateToHome(): void {
    this.router.navigate(['/']);
  }

  navigateToAbout(): void {
    this.router.navigate(['/about']);
  }

  navigateToContact(): void {
    this.router.navigate(['/contact']);
  }

  toggleMobileNav(): void {
    const navElement = document.getElementById('main-nav-collapse');
    if (navElement) {
      navElement.classList.toggle('show');
    }
  }

  getHeaderStyles(): { [key: string]: string } {
    if (!this.isImage) {
      return {
        'background-color': this.isTransparent ? 'transparent' : '#f8f9fa'
      };
    }

    // Always show background image to match section
    return {
      'background-image': `url(${this.backgroundImage})`,
      'background-size': 'cover',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'background-attachment': 'fixed'
    };
  }

    getScrolledHeaderStyles(): { [key: string]: string } {
    return {
      'background-image': `url(${this.backgroundImage})`,
      'background-size': 'cover',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
    };
  }
}
